import { render, staticRenderFns } from "./textareatemplate.vue?vue&type=template&id=69e8bc36&scoped=true&"
import script from "./textareatemplate.vue?vue&type=script&lang=js&"
export * from "./textareatemplate.vue?vue&type=script&lang=js&"
import style0 from "./textareatemplate.vue?vue&type=style&index=0&id=69e8bc36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e8bc36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VList,VListItem,VMenu,VTextarea})
